import Swiper, { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

class SliderLogo {
	constructor() {
		this.selector = document.querySelector(".swiper-slider-logos");

		if (this.selector) {
			this.swiper = new Swiper(this.selector, {
				modules: [Autoplay],
				slidesPerView: 3,
				loop: true,
				speed: 3000,
				allowTouchMove: false,
				preventClicks: true,
				autoplay: {
					delay: 1,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				},
				breakpoints: {
					768: {
						slidesPerView: 5,
					},
					1024: {
						slidesPerView: 7,
					},
				},
			});
		}
	}
}
export default SliderLogo;
